<template>
  <!-- begin sidebar nav -->
  <ul class="nav" v-if="menus">
    <li class="nav-search" v-if="pageOptions.pageSidebarSearch">
      <div class="menu-search">
        <input
          type="text"
          v-on:keyup="handleSidebarFilter"
          class="form-control"
          placeholder="Sidebar menu filter..."
          v-on:blur="handleCollapNav"
          ref="sidebarSearch"
          autocomplete="off"
        />
      </div>
    </li>

    <template v-for="menu in favoritesMenus">
      <sidebar-nav-list
        class="pt-2"
        v-bind:menu="menu"
        v-bind:scrollTop="scrollTop"
        v-bind:key="menu.path"
        v-bind:status="menu.status"
        v-on:collapse-other="handleCollapseOther(menu)"
        v-on:show-float-submenu="handleShowFloatSubmenu"
        v-on:hide-float-submenu="handleHideFloatSubmenu"
      ></sidebar-nav-list>
    </template>

    <li class="nav-header">Navigation</li>
    <template v-for="menu in menus">
      <sidebar-nav-list
        ref="sidebarNavList"
        v-bind:menu="menu"
        v-bind:scrollTop="scrollTop"
        v-bind:key="menu.path"
        v-bind:status="menu.status"
        v-on:collapse-other="handleCollapseOther(menu)"
        v-on:show-float-submenu="handleShowFloatSubmenu"
        v-on:hide-float-submenu="handleHideFloatSubmenu"
      ></sidebar-nav-list>
    </template>
    <!-- begin sidebar minify button -->
    <li>
      <a
        href="javascript:;"
        class="sidebar-minify-btn"
        v-on:click="handleSidebarMinify()"
      >
        <i class="fa fa-angle-double-left"></i>
      </a>
    </li>
    <!-- end sidebar minify button -->
  </ul>
  <!-- end sidebar nav -->
</template>

<script>
import navigations from '@/config/navigations'
import portalNav from '@/config/portal-navigations'
import SidebarNavList from './SidebarNavList.vue'
import PageOptions from '../../config/PageOptions.vue'

export default {
  name: 'SidebarNav',
  props: ['scrollTop'],
  components: {
    SidebarNavList
  },
  mounted() {
    this.$refs.sidebarSearch.setAttribute('autocomplete', 'off');
    setTimeout(() => {
      this.$refs.sidebarSearch.value = '';
    }, 100);
  },
  data() {
    return {
      pageOptions: PageOptions
    }
  },
  computed: {
    menus() {
      if (this.$store.getters.isStaffLogin) {
        return this.getAllowedNavItems(navigations)
      }

      return this.getAllowedNavItems(portalNav)
    },
    favoritesMenus() {
      if (this.$store.getters.isStaffLogin) {
        return this.getFavoriteNavItems(navigations)
      }
      return []
    }
  },
  methods: {
    getAllowedNavItems(navItems) {
      const menuFavorites = this.$store.state.authUser.menu_favorites ? this.$store.state.authUser.menu_favorites : [] // Favorites array
      let _allowNavItems = []

      for (let nav of navItems) {
        if (nav.children && nav.children.length > 0) {
          let _children = this.getAllowedNavItems(nav.children)

          if (_children.length > 0) {
            _allowNavItems.push({
              ...nav,
              children: _children
            })
          }
        }
        if (this.$store.state.authUser) {
          if (this.$store.state.authUser.permissions.includes(nav.permission)) {
            _allowNavItems.push(
              Object.assign(
                { is_favorite: menuFavorites ? menuFavorites.includes(nav.path) : false },
                nav
              )
            )
          }
        }
      }

      // return navItems
      return _allowNavItems
    },
    getFavoriteNavItems(navItems, isTopLevel = true) {
      const menuFavorites = this.$store.state.authUser.menu_favorites ? this.$store.state.authUser.menu_favorites : [] // Favorites array

      let favoriteChildren = []

      for (let nav of navItems) {
        // Recursively process child nodes
        if (nav.children && nav.children.length > 0) {
          favoriteChildren = favoriteChildren.concat(
            this.getFavoriteNavItems(nav.children, false)
          )
        }

        // Add current item if it's a favorite
        if (menuFavorites.includes(nav.path)) {
          if (this.$store.state.authUser.permissions.includes(nav.permission)) {
            favoriteChildren.push({
              path: nav.path,
              title: nav.title,
              permission: nav.permission,
              is_favorite: true
            })
          }
        }
      }

      // Add the "favorites" wrapper only at the topmost level
      if (isTopLevel && favoriteChildren.length > 0) {
        return [
          {
            title: 'favorites',
            icon: 'fas fa-star',
            label: 'NEW',
            children: favoriteChildren
          }
        ]
      }

      return favoriteChildren
    },
    handleShowFloatSubmenu: function(menu, offset) {
      this.$emit('show-float-submenu', menu, offset)
    },
    handleHideFloatSubmenu: function() {
      this.$emit('hide-float-submenu')
    },
    handleCollapseOther: function(menu) {
      for (var i = 0; i < this.menus.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu)
      }
    },
    handleSidebarMinify: function() {
      this.pageOptions.pageSidebarMinified = !this.pageOptions
        .pageSidebarMinified
    },
    handleSidebarFilter: function(e) {
      var value = e.target.value.toLowerCase()

      var filterMenu = (menu, refList) => {
        var hasMatch = false

        for (var i = 0; i < menu.length; i++) {
          var item = menu[i]

          var title = this.$t(`navigations.${item.title}`).toLowerCase()
          var children = item.children

          if (title.search(value) > -1) {
            hasMatch = true
            refList[i].show()
            if (children) {
              refList[i].searchExpand()
              filterMenu(children, refList[i].$refs.sidebarNavList)
            }
          } else if (children) {
            var childMatch = filterMenu(
              children,
              refList[i].$refs.sidebarNavList
            )
            if (childMatch) {
              hasMatch = true
              refList[i].searchExpand()
            } else {
              refList[i].hide()
            }
          } else {
            refList[i].hide()
          }
        }

        return hasMatch
      }

      if (value) {
        filterMenu(this.menus, this.$refs.sidebarNavList)
      } else {
        // Reset the visibility of all menu items if the filter is cleared
        var resetMenu = (menu, refList) => {
          for (var i = 0; i < menu.length; i++) {
            refList[i].show()
            if (menu[i].children) {
              refList[i].searchExpand()
              resetMenu(menu[i].children, refList[i].$refs.sidebarNavList)
            }
          }
        }
        resetMenu(this.menus, this.$refs.sidebarNavList)
      }
    },
    handleCollapNav() {
      if (this.$refs.sidebarSearch.value.length == 0) {
        for (var i = 0; i < this.menus.length; i++) {          
          this.$refs.sidebarNavList[i].collapse()
          this.$refs.sidebarNavList[i].handleCollapseOther()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form-control {
  background: none;
  border: none;
  padding-left: 0;
  padding-right: 0;
  border-bottom: 1px solid rgba(#ffff, 0.2);
  color: #ffff;
  border-radius: 0px;
}
.form-control:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.menu-search {
  padding: 4px 20px;
}
</style>
